module.exports = __webpack_public_path__ + "img/visu-pressage@2x.77fe3575.jpg";